// Module
var code = `<h2 class="section-header section-header--upper-margin">Loan Documents</h2>

<div ng-if="\$ctrl.loan.loanDocuments.length === 0" class="empty-message">
  Loan has no attached documents. Click on 'Add new document' to create a new one
</div>

<div ng-repeat="document in \$ctrl.loan.loanDocuments">
  <table class="table">
    <tbody>
    <tr>
      <td class="label">Document:</td>
      <td class="values">
        <file-id-upload
          ng-model="document.fileId"
          single-file="true"
          max-files="1"
          show-file-name="true"
          enable-webcam="false"
          show-remarks="false"
          required>
        </file-id-upload>
      </td>
    </tr>
    <tr>
      <td class="label">Name:</td>
      <td class="values">
        <input type="text" ng-model="document.name" maxlength="64"/>
      </td>
    </tr>
    <tr ng-if="\$ctrl.propertyConfigService.visible('loan', 'document', 'document_type')">
      <td class="label">Document Type:</td>
      <td class="values">
        <select
          ng-model="document.documentType"
          ng-options="t.value as t.label for t in \$ctrl.documentTypes"
          ng-required="\$ctrl.propertyConfigService.required('loan', 'document', 'document_type')">
        </select>
      </td>
    </tr>
    <tr>
      <td class="label">Document Number:</td>
      <td class="values">
        <input type="text" ng-model="document.documentNumber" maxlength="32"/>
      </td>
    </tr>
    <tr>
      <td class="label">Remarks:</td>
      <td class="values">
        <input type="text" ng-model="document.remarks" maxlength="256"/>
      </td>
    </tr>
    <tr ng-if="\$ctrl.propertyConfigService.visible('loan', 'document', 'document_status')">
      <td class="label">Status:</td>
      <td class="values">
        <select
          ng-model="document.status"
          ng-options="s.value as s.label for s in \$ctrl.documentStatuses"
          ng-required="\$ctrl.propertyConfigService.required('loan', 'document', 'document_status')">
        </select>
      </td>
    </tr>
    <tr>
      <td></td>
      <td>
        <button class="btn btn-danger" ng-click="\$ctrl.deleteDocument(\$index)">Delete document</button>
      </td>
    </tr>
    </tbody>
  </table>
</div>

<div class="summary-actions">
  <button class="btn" ng-click="\$ctrl.addDocument()">Add new document</button>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/documents/loan-documents.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;